import { DateTime } from 'luxon';

export const formatDateAndTime = (dateString: string | null, timeZone?: string): string => {
  if (!dateString) return 'N/A';
  let dt = DateTime.fromISO(dateString);
  if(timeZone) dt = dt.setZone(timeZone);
  return dt.toFormat('dd MMM yyyy hh:mm a');
};

export const formatDate = (dateString: string | null): string => {
  if (!dateString) return 'N/A';
  return DateTime.fromISO(dateString).toFormat('dd MMM yyyy');
};
